@if (show()) {
  <header>
    <h2 class="header">{{ "deposit_sepa_title" | translate }}</h2>
  </header>
  <section class="details-container">
    <article class="details">
      <div>
        <sepa-qr-tile-new [tiles]="tiles"></sepa-qr-tile-new>
      </div>
      <div class="details__reference-number">
        <sepa-qr-tile-new [tiles]="referenceNumberTiles"></sepa-qr-tile-new>
      </div>
      <p class="details__warning-text">{{ "deposit_sepa_reference_warning_text" | translate }}</p>
    </article>
    @if (!isGBPBankTransfer) {
      <article class="qr-code">
        <p class="qr-code__heading">{{ "or_scan_qr_code" | translate }}</p>
        <qrcode
          class="qr-code__code"
          [qrdata]="qrValue"
          [width]="180"
          [errorCorrectionLevel]="'H'"
        [allowEmptyString]="true"></qrcode>
      </article>
    }
  </section>
  @if (isFiatEuro) {
    <footer class="footer">
      {{ "deposit_sepa_disclaimer_text" | translate }}
    </footer>
  }
}
